module.exports = __webpack_public_path__ + "img/logo-6.8e8f55f4.png";